import axios from 'axios'
import store from '@/store'
import {  Loading } from 'element-ui'
// import Cookies from 'js-cookie'
export function exportExcel(url, options, excelName) {
  // let token = getToken();
  // let token = window.sessionStorage.getItem("token");
  // let jsonObj = JSON.parse(token);
  let  downloadLoadingInstance = Loading.service({ 
    text: "正在处理...", 
    spinner: "el-icon-loading", 
    background: "rgba(0, 0, 0, 0.7)", })

  return new Promise((resolve, reject) => {
    axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
    axios({
      method: 'post',
      url: url, // 请求地址
      data: options, // 参数
      responseType: 'blob', // 表明返回服务器返回的数据类型
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: 'Bearer ' + store.getUser().access_token
      }
    }).then(
      response => {
        downloadLoadingInstance.close();

        resolve(response.data)
        let blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        })
        let date = new Date()
        let newTime =
               date.getFullYear() +
          '-' +
          (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1) +
          '-' +
          date.getDate()
        let fileName = excelName + newTime + '.xls'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          // 释放内存
          window.URL.revokeObjectURL(link.href)
        }
      },
      err => {
        downloadLoadingInstance.close();

        reject(err)
      }
    )
  })
}
//
//
// 1
